<template>
    <div>
        <section class="xlrclh">
            <img
                class="top-img"
                src="./../assets/imgs/69/title-bg.png"
                alt=""
            />
            <div class="technological-process">
                <div class="rhtj mar-t2">
                    <img
                        class="top"
                        src="./../assets/imgs/69/title-1.png"
                        alt=""
                    />
                    <div class="content">
                        <div
                            class="title"
                            style="
                                font-weight: bold;
                                font-size: 0.34rem;
                                margin-top: 0.13rem;
                            "
                        >
                            <span class="hollow-cricle"></span
                            >（一）一次性购房补贴申请条件
                        </div>
                        <div class="des mar-t2">
                            <div>
                                一次性购房补贴是指向符合资格条件的人才一次性发放的补贴，享受了一次性购房补贴后，不能再申领分年度购房补贴。申请人须同时具备以下条件：
                            </div>
                            <div>1.符合成都市购房资格条件；</div>
                            <div>
                                2.取得成都市人才安居资格或入选“天彭菁英计划”（含原“金彭人才计划”入选者，下同）；
                            </div>
                            <div>
                                3.所购住房为申请人在本办法印发生效后在彭州市购买且拥有的唯一住房；
                            </div>
                            <div>
                                4.所购住房权利性质为商品房，房屋用途为住宅（含住宅类公寓）；
                            </div>
                            <div>5.所购住房产权应为申请人所有；</div>
                            <div>
                                6.未受过刑事处罚，无尚未查清的犯罪嫌疑，无正在接受审计、纪律审查、监察调查等情况。
                            </div>
                        </div>
                        <div
                            class="title"
                            style="
                                font-weight: bold;
                                font-size: 0.34rem;
                                margin-top: 0.13rem;
                            "
                        >
                            <span class="hollow-cricle"></span
                            >（二）分年度购房补贴申请条件
                        </div>
                        <div class="des mar-t2">
                            <div>
                                分年度购房补贴是指按标准分5年等额向符合资格条件的人才发放的补贴，享受了分年度购房补贴后，不能再申领一次性补贴。申请人须同时具备以下条件：
                            </div>
                            <div>
                                1.符合成都市购房资格条件且入选“天彭菁英计划”；
                            </div>
                            <div>
                                2.与彭州市用人单位签订劳动合同并缴纳社会保险（劳动合同签订单位与社会保险缴纳单位须一致）；
                            </div>
                            <div>
                                3.所购住房为申请人在本办法印发生效后在彭州市购买的住房；
                            </div>
                            <div>
                                4.所购住房权利性质为商品房，房屋用途为住宅（含住宅类公寓）；
                            </div>
                            <div>5.所购住房产权应为申请人所有；</div>
                            <div>
                                6.未受过刑事处罚，无尚未查清的犯罪嫌疑，无正在接受审计、纪律审查、监察调查等情况。
                            </div>
                        </div>
                    </div>
                </div>
                <div class="sxcl">
                    <img
                        class="top"
                        src="./../assets/imgs/69/title-2.png"
                        alt=""
                    />
                    <div class="content">
                        <div class="des">
                            （一）《成都市急需紧缺人才和高端人才目录》中的A、B类人才和《“天彭菁英计划”人才分类目录（试行）》中的国际顶尖人才和国家领军人才补贴150万元。
                        </div>
                        <div class="des">
                            （二）《成都市急需紧缺人才和高端人才目录》中的C类人才和《“天彭菁英计划”人才分类目录（试行）》中的地方高级人才补贴40万元。
                        </div>
                        <div class="des">
                            <div>
                                （三）《成都市急需紧缺人才和高端人才目录》中的D类人才和《“天彭菁英计划”人才分类目录（试行）》中的产业菁英人才、事业单位引进人才按以下标准给予购房补贴：
                            </div>
                            <div>1.正高级职称专业技术人才补贴20万元；</div>
                            <div>
                                2.取得博士研究生学历且获得相应学位的国内外高校毕业生，高级技师，副高级职称专业技术人才，省级技能大师工作室领衔人，高级社会工作师补贴15万元；
                            </div>
                            <div>
                                3.取得硕士研究生学历且获得相应学位的国内外高校毕业生，成都市级技能大师工作室领衔人
                                ，成都市级工艺美 术大师补贴10万元；
                            </div>
                            <div>
                                4.世界大学排名前50的海外高校应届本科毕业生补贴5万元。
                            </div>
                        </div>
                    </div>
                </div>

                <div class="gmlc">
                    <img
                        class="top"
                        src="./../assets/imgs/69/title-3.png"
                        alt=""
                    />
                    <div class="content">
                        <div class="des mar-t3">
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">1</div>
                                    <div class="line-title">通知</div>
                                </div>
                                <div class="line-content">
                                    每年由市住建局发布申报通知，印发各相关单位，组织开展有关工作。
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">2</div>
                                    <div class="line-title">申请</div>
                                </div>
                                <div class="line-content">
                                    符合条件的申请人向所在单位提交购房补贴申请，经主管部门初审后，报市住建局。
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">3</div>
                                    <div class="line-title">审核</div>
                                </div>
                                <div class="line-content">
                                    由市住建局牵头，会同相关部门核查申请人相关资格条件后，提出拟发放购房补贴建议方案。
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">4</div>
                                    <div class="line-title">审定</div>
                                </div>
                                <div class="line-content">
                                    市委人才工作领导小组召开专题会议对拟发放购房补贴建议方案进行审议后按程序审定。
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">5</div>
                                    <div class="line-title">公示</div>
                                </div>
                                <div class="line-content">
                                    由市住建局将审定的拟发放购房补贴人员名单在申请人所在单位和相关媒体网站公示5个工作日，公示无异议或异议不成立的，报送市委人才办备案。
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line-top">
                                    <div class="line-num">6</div>
                                    <div class="line-title">发放</div>
                                </div>
                                <div class="line-content">
                                    由市委人才办会同市财政局将购房补贴拨付至各主管部门，由主管部门拨付至用人单位，由用人单位拨付至人才个人账户。
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="contact" style="margin-top: 0.8rem">
                    <img
                        class="top"
                        src="./../assets/imgs/69/title-4.png"
                        alt=""
                    />
                    <div class="content">
                        <div class="number">
                            <span class="label">市住建局：</span>
                            <div>
                                <a href="tel:028-83701718">028-83701718</a>
                            </div>
                        </div>
                        <div class="unit">
                            <span class="label">市委人才办：</span>
                            <a href="tel:028-83460788">028-83460788</a>
                        </div>
                    </div>
                </div>
                <div class="codes">
                    <img class="code" src="../assets/imgs/69/code.png" />
                    <img class="text" src="../assets/imgs/69/text.png" />
                </div>
            </div>
        </section>
        <!-- <call phone="028-83221725"></call> -->
    </div>
</template>

<script>
import call from "../components/call.vue";
export default {
    data() {
        return {};
    },

    components: {
        call,
    },

    mounted() {},

    methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";
.xlrclh {
    background-color: $base-back;
    .top-img {
        width: 7.26rem;
        height: 5.6rem;
    }
    .contact {
        position: relative;
        margin-top: 0.22rem;

        .top {
            width: 7.03rem;
            height: 1.37rem;
            margin-left: -0.18rem;
        }
        .content {
            width: 6.85rem;
            background: #ffffff;
            margin: -0.45rem auto 0;
            padding: 0.33rem;
            padding-right: 0.2rem;
            box-sizing: border-box;
            border-radius: 0rem 0rem 0.26rem 0.26rem;
            padding-top: 0.28rem;
            font-size: 0.3rem;
            font-weight: bold;
            text-align: left;
            color: #4e4e4e;
            .number {
                box-sizing: border-box;
                padding-left: 1.6rem;
                position: relative;
                line-height: 0.44rem;

            }
            .unit {
                margin-top: 0.15rem;
                box-sizing: border-box;
                padding-left: 1.9rem;
                position: relative;
                line-height: 0.44rem;

            }
            .site {
                margin-top: 0.15rem;
                box-sizing: border-box;
                padding-left: 1rem;
                position: relative;
                line-height: 0.3rem;
            }
            .label {
                position: absolute;
                left: 0;
                top: 0;
            }
        }
    }
    .technological-process {
        transform: translateY(-1.9rem);

        .rhtj {
            position: relative;
            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }
            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }
                .des {
                    font-size: 0.26rem;
                    // font-weight: 500;
                    color: #4e4e4e;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.33rem;
                    text-align: left;
                    // line-height: 0.44rem;
                    position: relative;
                    overflow: hidden;
                }
            }
        }

        .sxcl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }
            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;
            line-height: 0.44rem;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }
                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.35rem 0.23rem 0.3rem;
                    margin-top: 0.5rem;
                    position: relative;
                }
            }
        }

        .gmlc {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }
            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.55rem auto;
                padding: 0 0.33rem 0.35rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }
                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.3rem 0.23rem;
                    font-size: 0.26rem;
                    font-weight: 500;
                    color: #4e4e4e;
                    .line-item {
                        font-size: 0.26rem;
                        position: relative;
                        z-index: 3;
                        .line {
                            position: absolute;
                            width: 0.02rem;
                            height: 100%;
                            border-left: 0.02rem dashed #739bfe;
                            left: 0.2rem;
                            z-index: 0;
                            //   background-color: #739bfe;
                        }
                        .line-title {
                            font-size: 0.3rem;
                            font-weight: bold;
                            color: #3d5aa3;
                        }
                        .line-top {
                            display: flex;
                            width: 3.31rem;
                            height: 0.49rem;
                            background-image: url(../assets/imgs/25/label.png);
                            background-size: 100% 100%;
                            z-index: 99;
                            display: flex;
                            align-items: center;
                            box-sizing: border-box;
                            padding-left: 0.08rem;
                            .line-num {
                                width: 0.39rem;
                                height: 0.39rem;
                                background: #fff;
                                color: #3d5aa3;
                                display: inline-flex;
                                border-radius: 50%;
                                justify-content: center;
                                align-items: center;
                                margin-right: 0.14rem;
                                position: relative;
                                z-index: 3;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                font-size: 0.28rem;
                                font-weight: bold;
                            }
                        }
                        .line-content {
                            //   border-left: 0.02rem dashed #739bfe;
                            padding-bottom: 0.32rem;
                            margin-left: 0.2rem;
                            padding-left: 0.32rem;
                            padding-top: 0.15rem;
                            word-break: break-all;
                            line-height: 0.44rem;
                        }
                    }
                }
            }
        }

        .codes {
            margin: 0 auto;
            margin-top: 0.25rem;
            width: 6.85rem;
            background: #fff;
            padding: 0.3rem;
            box-sizing: border-box;
            border-radius: 0.26rem;
            padding-top: 0.28rem;
            font-size: 0.26rem;
            font-weight: 500;
            color: #4e4e4e;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .code {
                width: 1.94rem;
                height: 1.94rem;
            }
            .text {
                height: 1.94rem;
            }
        }
    }
}
</style>
